// 详细推荐接口拦截token验证逻辑
import commonApi from "@/apis/public-api.js";
import VueClicaptcha from "vue-clicaptcha";
import Cookies from "js-cookie";
export default {
  data() {
    return {
      token: "",
    };
  },
  created() {},
  mounted() {},
  methods: {
    /**
     * 获取当前有效的Token
     * 注意：callback和调用处的函数相同会引起循环调用
     */
    async fetchValidToken(callbackFun, params) {
      const res = await commonApi.getValidTokenApi({
        timestamp: new Date().getTime(),
      });
      // const res = {
      //   data: {
      //     token:
      //       "7ea6950e682ff3a1d5c66c37c160670e7e7fdc3709d8235f8332eac3f57fb3cf",
      //   },
      // };

      // this.token =
      //   "7ea6950e682ff3a1d5c66c37c160670e7e7fdc3709d8235f8332eac3f57fb3cf" ||
      //   res.data.token;
      this.token = res.data.token;
      if (!this.token) {
        VueClicaptcha({
          src: `${window.VUE_APP_API_ROOT}oil/h5/get_captcha`, // 后端地址
          success: "验证成功！", // 成功提示，默认为“验证成功！”
          error: "未点中正确区域，请重试！", // 错误提示，默认为“未点中正确区域，请重试！”
          callback: async () => {
            await this.fetchTokenByVerificationInfo(callbackFun, params);
          },
        });
      } else {
        if (callbackFun) {
          callbackFun(res.data.token, params);
        }
        return res.data.token;
      }
    },
    /**
     * 结合验证信息获取Token
     */
    async fetchTokenByVerificationInfo(callbackFun, params) {
      const res = await commonApi.getTokenByVerificationInfoApi({
        info: Cookies.get("clicaptcha_info"),
      });
      this.token = res.data.token;
      if (res.data.token && callbackFun) {
        callbackFun(res.data.token, params);
      }
      return res.data.token;
    },
  },
};
